import React from 'react'

export default function NotFoundPage() {
  return (
    <div>
      <h1 className='text-red-500'>Not found page</h1>
    </div>
  )
}
